/**
 * Sorts array by the field and group elements with the same field
 * Typescript version: https://gist.github.com/robmathers/1830ce09695f759bf2c4df15c29dd22d#gistcomment-3553222
 * Original version: https://stackoverflow.com/a/34890276/8369352
 * @param xs Source Array of objects
 * @param keys Sort keys
 * @returns
 * Examlple: Ex: [{id: 1, group: 'A'}, {id: 2, group: 'B'}, {id: 3, group: 'A'}],   'group'
 *    =>
 *     {A: [{id: 1, group: 'A'}, {id: 3, group: 'A'}], B: [{id: 2, group: 'B'}]}
 */
const groupBy = <T>(arr: T[], keys: (keyof T)[]): { [key: string]: T[] } => {
  return arr.reduce((storage, item) => {
    const objKey = keys.map((key) => `${item[key]}`).join(':')
    if (storage[objKey]) {
      storage[objKey].push(item)
    } else {
      storage[objKey] = [item]
    }
    return storage
  }, {} as { [key: string]: T[] })
}

export default {
  groupBy,
}
